var React = require('react');

function Ru (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"6666.7","fill":"#D52B1E","width":"15000","height":"3333.3","key":0}),React.createElement("rect",{"y":"3333.3","fill":"#0039A6","width":"15000","height":"3333.3","key":1}),React.createElement("rect",{"y":"0","fill":"#FFFFFF","width":"15000","height":"3333.3","key":2})]);
}

Ru.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 15000 10000","enableBackground":"new 0 0 15000 10000","xmlSpace":"preserve"};

module.exports = Ru;

Ru.default = Ru;
